// extracted by mini-css-extract-plugin
export default {"root":"Header_root__e1b7h","logo":"Header_logo__hLUwo","logo2":"Header_logo2__T8Zge","connect_btn":"Header_connect_btn__c6n7m"};